document.querySelectorAll("homepage-slideshow").forEach(homepageSlideshow => {
	let imageList = homepageSlideshow.querySelectorAll("img");
	let largeView = document.querySelector(homepageSlideshow.getAttribute("data-large-view"));
	let ul = homepageSlideshow.querySelector("ul");
	let mobileUl = ul.cloneNode(true);
	mobileUl.classList.remove("thumbs");
	let timeoutAutoClick = null;

	selectLargeView(0);
	setupMobileUl();

	imageList.forEach(img => {
		let link = img.parentElement;
		link.addEventListener("click", hijackLink);
	});

	function hijackLink(e) {
		if(e.ctrlKey || e.metaKey) {
			return;
		}

		if(!homepageSlideshow.classList.contains("popup")) {
			e.stopPropagation();
		}

		e.preventDefault();
		let li = this.closest("li");
		let index = Array.from(ul.children).indexOf(li);

		if(window.innerWidth > 480) {
			selectLargeView(index);
			return;
		}
		else {
			homepageSlideshow.classList.add("popup");
			scrollToClickedThumb(index);
			window.addEventListener("hashchange", checkHash);
			window.addEventListener("keypress", closePopup);
			homepageSlideshow.addEventListener("click", closePopup);
		}

		location.hash = (new URL(this.href)).pathname;
	}

	function selectLargeView(num) {
		if(timeoutAutoClick) {
			clearTimeout(timeoutAutoClick);
			timeoutAutoClick = null;
		}

		let newLargeViewImage = document.createElement("img");
		newLargeViewImage.addEventListener("load", () => {
			newLargeViewImage.classList.add("new");

			setTimeout(() => {
				Array.from(largeView.children).forEach(img => {
					if(img !== newLargeViewImage) {
						img.remove();
					}
					newLargeViewImage.classList.remove("new");
				});
			}, 1000);
		});
		largeView.prepend(newLargeViewImage);

		let link = ul.children[num].firstElementChild;
		newLargeViewImage.src = link.href;
		homepageSlideshow.querySelectorAll("li.selected").forEach(li => { li.classList.remove("selected"); });
		link.parentElement.classList.add("selected");

		timeoutAutoClick = setTimeout(function() {
			if(num >= ul.children.length - 1) {
				num = -1;
			}

			selectLargeView(num + 1);
		}, 10000);
	}

	function setupMobileUl() {
		mobileUl.querySelectorAll("li").forEach(li => {
			let link = li.querySelector("a");
			let img = link.querySelector("img");
			img.src = link.href;
			li.appendChild(img);
			link.remove();
		});
		mobileUl.classList.add("mobile");
		ul.after(mobileUl);
	}

	function checkHash() {
		if(location.hash.length < 2) {
			closePopup();
		}
	}

	function closePopup(e) {
		if(e && e.key && e.key !== "Escape") {
			return;
		}

		if(!homepageSlideshow.classList.contains("popup")) {
			return;
		}

		homepageSlideshow.removeEventListener("click", closePopup);
		window.removeEventListener("keypress", closePopup);
		window.removeEventListener("hashchange", checkHash);

		homepageSlideshow.classList.remove("popup");
		location.hash = "";
	}

	function scrollToClickedThumb(index) {
		mobileUl.scrollLeft = index * innerWidth;
	}
});
